(function (w, $) {

    // 1) No validation allowed outsite the scope of the form.
    // 2) Can not allow nested forms in ASP.NET
    
    let recaptcha2Invisible;
    let recaptchaLoaded = false;

    w.PubSub.subscribe('recaptcha.callback.loaded', function () {
        recaptchaLoaded = true;
    });

    w.PubSub.subscribe('popup.shown', function (topic, data) {

        if (data.popupId !== 1) {
            return;
        }

        const $form = $('#popupValidationForm');
        var $email = $('#newsletterPopupEmail');

        $email.on('input', () => { w.recaptcha_load(); });

        function validateAndSubscribe() {
            $form.validate();

            if ($email.valid()) {
                if (!recaptchaLoaded) {
                    showError('Recaptcha is not loaded yet. Please try again in a second.');
                    return;
                }

                if (!recaptcha2Invisible) {
                    const recaptchaSitekey = $form.find('.js-sitekey').data('sitekey');
                    recaptcha2Invisible = new w.Recaptcha2Invisible('newsletter_sub_popup_recaptcha2Container', recaptchaSitekey);
                }

                recaptcha2Invisible.execute(
                    function(recaptcha2Token) {
                        $.ajax({
                                url: window.R + 'handlers/public/userdata.ashx',
                                type: 'POST',
                                data: {
                                    action: 'SubscribeToNewsletter',
                                    email: $email.val(),
                                    recaptcha2Token: recaptcha2Token
                                },
                                dataType: 'text'
                            })
                            .done(function() {
                                let $closePopupButton = $('.ui-dialog-titlebar-close');
                                if (!$closePopupButton.length)
                                    $closePopupButton = $('.noty_close');

                                let redirectUrl = $form.find('.js-urls').data('url-redirect');

                                if (redirectUrl) {

                                    const msgId = $form.find('.js-messages').data('msg-success-id');
                                    if (msgId) {
                                        redirectUrl = '{0}?msgId={1};{2}'.format(redirectUrl, msgId, $email.val());
                                    }

                                    $closePopupButton.click();
                                    window.location.replace(window.R + redirectUrl);

                                    return;
                                }

                                const msg = $form.find('.js-messages').data('msg-success');

                                const notyOptions = {
                                    layout: 'topCenter',
                                    type: 'success',
                                    maxVisible: 15,
                                    force: true,
                                    timeout: 5000,
                                    text: msg.format($email.val())
                                };

                                $closePopupButton.click();
                                w.noty(notyOptions);
                            })
                            .fail(function(ex) {
                                let msg = ex.statusText ? ex.statusText : 'Subscription failed due to unknown error';

                                try {
                                    msg = JSON.parse(ex.responseText).Message;
                                } catch (e) {
                                }

                                showError(msg);
                            });
                    },
                    function(error) {
                        showError(error);
                    }
                );
            }
        }

        function onInputKeyPress(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                validateAndSubscribe.apply(this);
            }
        }

        function showError(msg) {
            const notyOptions = {
                layout: 'topCenter',
                type: 'error',
                maxVisible: 15,
                force: true,
                timeout: 5000,
                text: msg
            };

            w.noty(notyOptions);
        }

        // Attach events for button subscribe button click and input keypress enter
        $form.find('.js-newsletter-subscription-subscribe').on('click', validateAndSubscribe);
        $email.on('keypress', onInputKeyPress);
    });
})(window, jQuery);